import * as React from 'react'
import {useState} from 'react'
import './ContentTabsRow.scss'
import PageComponent from './PageComponent'
import ReactMarkdown from 'react-markdown'
import joinClassNames from '../../helpers/joinClassNames'
import {GatsbyImage, IGatsbyImageData} from 'gatsby-plugin-image'
import RegisterButton from '../CTA/RegisterButton'
import {useTranslation} from 'react-i18next'

type Props = {
    id: string
    title?: string
    tabs: Array<{
        id: string
        title: string
        imageData: IGatsbyImageData
        imageAlt?: string
    }>
}

const ContentTabsRow = ({title, tabs}: Props) => {
    const {t} = useTranslation()

    const [currentTabTitle, setCurrentTabTitle] = useState(tabs[0].title)

    const currentTab = tabs.find((tab) => tab.title === currentTabTitle)

    return (
        <PageComponent>
            {!!title && <ReactMarkdown className={'has-text-centered'}>{title}</ReactMarkdown>}
            <div className={'page__content-tabs-row-tabs'}>
                {tabs.map((tab) => (
                    <button
                        key={tab.id}
                        className={joinClassNames(
                            'button is-small is-primary is-rounded',
                            currentTabTitle !== tab.title && 'is-outlined'
                        )}
                        onClick={() => setCurrentTabTitle(tab.title)}
                    >
                        {tab.title}
                    </button>
                ))}
            </div>
            <div className={'has-text-centered'}>
                {!!currentTab.imageData && <GatsbyImage image={currentTab.imageData} alt={currentTab.imageAlt} />}
            </div>
            <section className={'has-text-centered'}>
                <RegisterButton size={'medium'} isOutlined={false} isFullWidthMobile={false} />
                <p className={'has-text-dark mb-0 mt-4'}>{t('content-tabs-row_cta-trial')}</p>
            </section>
        </PageComponent>
    )
}

export default ContentTabsRow
